import * as React from 'react';

function SvgSearchOutline(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path d="M28.71 27.29l-7-7a10 10 0 10-1.42 1.42l7 7zM14 22a8 8 0 118-8 8 8 0 01-8 8z" />
    </svg>
  );
}

export default SvgSearchOutline;
